import React from 'react';
import { normalizeTrialAssetUrl } from '../../utils/trial-preview';

type Props = {
  iconUrl?: string | null;
  logoUrl?: string | null;
  name: string;
  className?: string;
  style?: React.CSSProperties;
  /** Light surfaces / small tiles: favicon before wide wordmarks. Large previews: logo first. */
  variant?: 'default' | 'onLight';
};

export const BrandLogo = ({
  iconUrl, logoUrl, name, className, style, variant = 'default',
}: Props) => {
  const ordered = variant === 'onLight'
    ? [iconUrl, logoUrl]
    : [logoUrl, iconUrl];
  const sources = Array.from(new Set(
    ordered
      .map((url) => normalizeTrialAssetUrl(url))
      .filter((url): url is string => !!url),
  ));
  const [attempt, setAttempt] = React.useState(0);
  const src = sources[attempt];
  const failed = sources.length > 0 && attempt >= sources.length;

  React.useEffect(() => {
    setAttempt(0);
  }, [iconUrl, logoUrl, variant]);

  const classes = ['FreeTrial__Brand__Logo', className].filter(Boolean).join(' ');

  if (!src || failed) {
    const initial = (name ?? '').trim().charAt(0).toUpperCase();

    return (
      <div className={`${classes} FreeTrial__Brand__Logo--placeholder`} style={style}>
        {initial || '?'}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name ?? ''}
      className={classes}
      style={style}
      referrerPolicy="no-referrer"
      onError={() => setAttempt((current) => current + 1)}
    />
  );
};
